import React, { useEffect, useState } from "react";
import useTradingStore from "../../store/useTradingStore";
import Balances from "./Balances";
import MarketTicker from "./MarketTicker";
import OrderBook from "./OrderBook";
import TradingChart from "./TradingChartWithBackendAPI";
import TradingInterface from "./TradingInterface";
import UserOrders from "./UserOrders";

const ExchangePageComponent = () => {
  const [selectedOrder, setSelectedOrder] = useState(null);
  const {
    selectedPair,
    setSelectedPair,
    pairs,
    fetchTradingPairs,
    marketSummary,
  } = useTradingStore();

  useEffect(() => {
    const fetchData = async () => {
      try {
        await fetchTradingPairs();
      } catch (error) {
        console.error("Error fetching trading data:", error);
      }
    };

    fetchData();
  }, [fetchTradingPairs]);

  const handleOrderSelect = (order) => {
    setSelectedOrder(order);
  };

  const getCurrentPairData = () => {
    if (!selectedPair || !marketSummary.data) return null;
    return marketSummary.data[selectedPair.replace("-", "_")];
  };

  return (
    <div className="bg-gray-900 text-white overflow-hidden flex flex-col mt-2 sm:mt-8 px-2 sm:px-4 lg:px-6" style={{
      background: 'radial-gradient(51.47% 93.67% at 92.92% 27.08%, #161837 0%, #161837 72.6%)'
    }}>
     
      {/* Top Header - Market Ticker */}
      <div className="w-full my-3 sm:mb-4 border border-[#2A356D] border-2 rounded-lg">
        <MarketTicker />
      </div>

      {/* Main Content Area - Mobile Stacked, Desktop Grid */}
      <div className="flex-1 flex flex-col lg:flex-row overflow-hidden gap-2 sm:gap-4 items-stretch">
        {/* Left Sidebar - Markets List */}
        {/* Mobile: Full width, Desktop: 20% */}
        <div className="w-full lg:w-[20%] order-1 lg:order-1 flex flex-col h-[600px] overflow-y-auto">
          <OrderBook pair={selectedPair} onOrderSelect={handleOrderSelect} />
        </div>

        {/* Main Trading Area */}
        {/* Mobile: Full width, Desktop: 45% */}
        <div className="w-full lg:w-[45%] flex flex-col overflow-hidden order-3 lg:order-2 h-[600px] overflow-y-auto">
          {/* Chart Container */}
          <div className="flex-1 bg-gray-850 border border-gray-700 rounded-lg h-[600px] overflow-y-auto ">
            <TradingChart height="100%" />
          </div>
        </div>

        {/* Right Sidebar - Trading Interface */}
        {/* Mobile: Full width, Desktop: 35% */}
        <div className="w-full lg:w-[35%] border border-gray-700 bg-gray-800 rounded-lg order-2 lg:order-3 h-[600px] overflow-y-auto flex flex-col">
          <TradingInterface selectedOrder={selectedOrder} />
        </div>
      </div>

      {/* User Orders Section - Mobile: Below main content, Desktop: Integrated */}
      <div className="w-full mt-2 sm:mt-4 order-4">
        <UserOrders />
      </div>
    </div>
  );
};

export default ExchangePageComponent;
